import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import { DateRangePicker } from 'react-dates';
import FavoriteActiveIcon from '../icons/favorite active';
import FavoriteIcon from '../icons/favorite';

import { MultiSelectInput } from '../multi-select';

import React from 'react';
import ReactDOM from 'react-dom';


const modalEl = document.getElementById('modal');

export class GeneralFilterModal extends React.Component {

    static defaultProps = {
        isOpened: true,
        linkId: 0
    };

    render() {
        const { isOpened, ...rest } = this.props;

        if (isOpened) {
            return ReactDOM.createPortal(<Modal {...rest} />, modalEl);
        }

        return null;
    }
}

const Modal = Component()(

    class Modal extends React.Component {
        store; // injected by Poa
        actions; // injected by Poa
        env; // injected by Poa
        t; // injected by Poa

        componentWillUnmount() {
            document.body.classList.remove('no-scroll');
        }

        selectedOptions = [
            'panels', 'name', 'managers', 'teamleads', 'operators', 'scouts', 'account-managers',
            'levels', 'nick', 'account_id', 'index', 'email'
        ];

        accountModalOptions = [
            { value: 'panels', label: 'Панель' },
            { value: 'name', label: 'ФИО' },
            { value: 'managers', label: 'Менеджер' },
            { value: 'teamleads', label: 'Тимлид' },
            { value: 'operators', label: 'Оператор' },
            { value: 'scouts', label: 'Скаут' },
            { value: 'account-managers', label: 'ММ' },
            { value: 'levels', label: 'Уровень' },
            { value: 'nick', label: 'Ник' },
            { value: 'account_id', label: 'ID' },
            { value: 'index', label: '№' },
            { value: 'email', label: 'Email' }];

        filterBy = observable({
            'index': '',
            'account_id': '',
            'name': '',
            'panels': [],
            'managers': [],
            'teamleads': [],
            'scouts': [],
            'operators': [],
            'account-managers': [],
            'levels': [],
            'nick': '',
            'email': ''
        });

        filterNames = observable({
            'index': '№',
            'account_id': 'ID',
            'name': 'ФИО',
            'panels': 'Пан',
            'managers': 'Менеджер',
            'teamleads': 'Тимлид',
            'scouts': 'Скаут',
            'operators': 'Оператор',
            'levels': 'Уровень',
            'account-managers': 'ММ',
            'nick': 'Ник',
            'email': 'Email'
        });

        coreFilterNames = {
            'panel': 'panels',
            'full_name': 'name',
            'manager': 'managers',
            'form_level': 'levels',
            'team_lead': 'teamleads',
            'scout': 'scouts',
            'account_manager': 'account-managers',
            'operator': 'operators',
            'nick': 'nick',
            'id': 'account_id',
            'number': 'index',
            'email': 'email'
        };

        reverseCoreFilterNames = {
            'panels': 'panel',
            'name': 'full_name',
            'managers': 'manager',
            'levels': 'form_level',
            'teamleads': 'team_lead',
            'operators': 'operator',
            'scouts': 'scout',
            'account-managers': 'account_manager',
            'nick': 'nick',
            'account_id': 'id',
            'index': 'number',
            'all': 'по всем',
            'email': 'email'
        };

        levelOptions = [
            { id: "1", title: "1" },
            { id: "2", title: "2" },
            { id: "3", title: "3" },
            { id: "4", title: "4" },
            { id: "5", title: "5" },
        ];

        selectValues = ['panels', 'managers', 'teamleads', 'scouts', 'operators', 'levels', 'account-managers'];

        focusedDateInput = observable(null);

        localState = observable({
            loading: false,
            activeTabIndex: 0,
            isEdit: false,
            search: {
                filter_by: this.filterBy
            },
            getProps: () => this.props,

        });

        onFilterByChange = (value, name) => {
            console.log(value, name);
            this.localState.search.filter_by[name] = value;
        };

        onLastSearchChange = searchString => {
            if (searchString.target) {
                this.localState.search.filter_by[searchString.target.name] = searchString.target.value;
            }
        };

        handleDatepickerFocusChange = focusedInput => {
            this.focusedDateInput.set(focusedInput);
        }


        handleSearchClick = action(async () => {
            this.props.onSearchClick(
                this.localState.search.filter_by
            );
            this.props.requestClose();
        });

        onClose = action(() => {
            this.props.requestClose();
        });

        onFavoriteClick = action(() => {
            this.props.handleShowFavorite();
        });

        render() {

            const { startDate, endDate } = this.store.generalProfile.filters;
            const { setDates } = this.actions.generalProfileActions;

            return (
                <div className='general_sidebar_filter_content'>
                    <div ref={node => (this.node = node)} className='body'>
                        <div className='container-info'>
                            <div className='general_sidebar-header'>
                                <div className='favorite_icon' onClick={this.onFavoriteClick}>
                                    {this.props.showFavorite ? <FavoriteActiveIcon /> : <FavoriteIcon />}
                                </div>

                                <div className='general_sidebar-header__search'>
                                    <div className='search__input input'>
                                        <input
                                            type='text'
                                            placeholder='search'
                                            value={this.props.searchString}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    this.handleSearchClick();
                                                }
                                            }}
                                            onChange={this.props.onSearchChange}>
                                        </input>
                                        <svg className='icon icon-search' onClick={this.onSearchClick} width='15px' height='15px' viewBox='0 0 15 15'
                                            version='1.1' xmlns='http://www.w3.org/2000/svg'>
                                            <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                                                <g fillRule='nonzero' fill='#DBDBDB'>
                                                    <path
                                                        d='M14.8163265,13.9346939 L11.2102041,10.3285714 C12.1040816,9.23877551 12.6428571,7.84285714 12.6428571,6.32142857 C12.6428571,2.83163265 9.81122449,0 6.32142857,0 C2.82857143,0 0,2.83163265 0,6.32142857 C0,9.81122449 2.82857143,12.6428571 6.32142857,12.6428571 C7.84285714,12.6428571 9.23571429,12.1071429 10.3255102,11.2132653 L13.9316327,14.8163265 C14.1765306,15.0612245 14.5714286,15.0612245 14.8163265,14.8163265 C15.0612245,14.5744898 15.0612245,14.1765306 14.8163265,13.9346939 Z M6.32142857,11.3846939 C3.52653061,11.3846939 1.25510204,9.11326531 1.25510204,6.32142857 C1.25510204,3.52959184 3.52653061,1.25510204 6.32142857,1.25510204 C9.11326531,1.25510204 11.3877551,3.52959184 11.3877551,6.32142857 C11.3877551,9.11326531 9.11326531,11.3846939 6.32142857,11.3846939 Z'></path>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                                <button onClick={this.handleSearchClick}>
                                    Поиск
                                </button>
                            </div>

                            <div className='filter_items_rows'>
                                <div className='item_row'>
                                    <div className='grid_item'>
                                            <span className='filter__label'>{this.t('period')}</span>
                                            <DateRangePicker
                                                disabled={this.props.datesDisabled}
                                                startDateId='1'
                                                endDateId='1'
                                                isOutsideRange={() => false}
                                                startDate={startDate}
                                                startDatePlaceholderText={this.t('from')}
                                                endDate={endDate}
                                                endDatePlaceholderText={this.t('to')}
                                                onDatesChange={setDates}
                                                focusedInput={this.focusedDateInput.get()}
                                                onFocusChange={this.handleDatepickerFocusChange}
                                                customArrowIcon='-'
                                                minimumNights={0}
                                                hideKeyboardShortcutsPanel={true}
                                            />
                                    </div>
                                </div>
                            </div>

                            <div className='filter_items_rows'>

                                {this.selectedOptions.map((searchRaw) => (
                                    <div className='item_row' key={searchRaw}>
                                        <div className='grid_item'>
                                            {this.filterNames[searchRaw]}
                                            <Observer>
                                                {() => (
                                                    this.selectValues.includes(searchRaw) ?
                                                        <div className='search__input input'>
                                                            <MultiSelectInput
                                                                editMode={true}
                                                                types={[searchRaw]}
                                                                current={this.localState.search.filter_by[searchRaw] || []}
                                                                onChange={this.onFilterByChange}
                                                                name={searchRaw}
                                                                options={this.levelOptions}
                                                            />
                                                        </div>
                                                        :
                                                        <div className='search__input input' style={{ padding: '0' }}>
                                                            <input
                                                                type='text'
                                                                name={searchRaw}
                                                                placeholder='поиск'
                                                                value={this.localState.search.filter_by[searchRaw] || ''}
                                                                style={{ width: '100%', borderRadius: '3px', height: '34px' }}
                                                                onChange={this.onLastSearchChange}>
                                                            </input>
                                                        </div>
                                                )}
                                            </Observer>
                                        </div>
                                    </div>
                                ))}

                            </div>
                            <div className='close_row'>
                                <button className='close_button' onClick={this.onClose}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
);
